'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxConnect = require('redux-connect');

var _flash = require('./flash');

var _flash2 = _interopRequireDefault(_flash);

var _gtm = require('./gtm');

var _gtm2 = _interopRequireDefault(_gtm);

var _launch = require('./launch');

var _launch2 = _interopRequireDefault(_launch);

var _cart = require('./cart');

var _cart2 = _interopRequireDefault(_cart);

var _order = require('./order');

var _order2 = _interopRequireDefault(_order);

var _loading = require('./loading');

var _loading2 = _interopRequireDefault(_loading);

var _presentation = require('./presentation');

var _presentation2 = _interopRequireDefault(_presentation);

var _country = require('./country');

var _country2 = _interopRequireDefault(_country);

var _orders = require('./orders');

var _orders2 = _interopRequireDefault(_orders);

var _user = require('./user');

var _user2 = _interopRequireDefault(_user);

var _postcode = require('./postcode');

var _postcode2 = _interopRequireDefault(_postcode);

var _addressBook = require('./addressBook');

var _addressBook2 = _interopRequireDefault(_addressBook);

var _addressForm = require('./addressForm');

var _addressForm2 = _interopRequireDefault(_addressForm);

var _pickupLocator = require('./pickupLocator');

var _pickupLocator2 = _interopRequireDefault(_pickupLocator);

var _quickOrder = require('./quickOrder');

var _quickOrder2 = _interopRequireDefault(_quickOrder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,
  reduxAsyncConnect: _reduxConnect.reducer,
  flash: _flash2.default,
  gtm: _gtm2.default,
  launch: _launch2.default,
  cart: _cart2.default,
  order: _order2.default,
  loading: _loading2.default,
  presentation: _presentation2.default,
  country: _country2.default,
  orders: _orders2.default,
  user: _user2.default,
  postcode: _postcode2.default,
  addressBook: _addressBook2.default,
  addressForm: _addressForm2.default,
  pickupLocator: _pickupLocator2.default,
  quickOrder: _quickOrder2.default
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/index.js
// module id = 2349
// module chunks = 0